export default {
  name: "app-header",
  created() {},
  data() {
    return {
      user_name: localStorage.user_name
    };
  },
  methods: {
    logOut() {
      this.$store.dispatch("LOGOUT");
    }
  }
};
